import type { ReactNode } from 'react';
import React from 'react';
import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { flex, space, themeGet } from 'styled-system';

import type { WithTheme } from '../../../theme/theme';
import { HeadlineH8, SubtitleST3 } from '../../Typography';

interface DetailsProps {
  label: string;
  description: string | ReactNode;
  isFirst: boolean;
  isActive: boolean;
  isCompleted: boolean;
}

type ThemedDetailsProps = WithTheme<DetailsProps>;

const containerCSS = ({ isFirst, isCompleted, isActive, theme }: ThemedDetailsProps) => css`
  color: ${themeGet(`colors.gray.${isCompleted || isActive ? 16 : 9}`)({
    theme,
  })};
  ${!isFirst &&
  css`
    margin-top: ${themeGet('space.sp_20')({ theme })}px;
  `}
`;

const Container = styled.span<any>`
  ${flex};
  ${space};
  ${containerCSS};
`;

const Label = styled(HeadlineH8)<any>`
  ${({ isCompleted, isActive }) =>
    (isCompleted || isActive) &&
    css`
      text-transform: uppercase;
    `}
`;

const Details = ({ label, description, isFirst, isActive, isCompleted }: DetailsProps) => (
  <Container isFirst={isFirst} isActive={isActive} isCompleted={isCompleted} flex="1" ml="sp_16">
    <Label isActive={isActive} isCompleted={isCompleted}>
      {label}
    </Label>
    <SubtitleST3>{description}</SubtitleST3>
  </Container>
);

export default Details;
